import axios from 'axios';

const check_client_url = 'check-client/';
const client_url = 'clients/';
const client_contacts_url = 'client-contacts/';

export default {
    async checkClient(phone, postal_code, email, address){
        let url = check_client_url + '?';

        if(phone !== null && phone !== undefined){
            url += `phone=${phone}&`;
        }

        if(postal_code !== null && postal_code !== undefined){
            url += `postal_code=${postal_code}&`;
        }

        if(email !== null && email !== undefined){
            url += `email=${email}&`;
        }

        if(address !== null && address !== undefined){
            url += `address=${address}&`;
        }

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        })
    },
    async createClient (new_client) {
        return axios.post(client_url, new_client)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createClientContact (contact) {
        return axios.post(client_contacts_url, contact).then((response) => {
            return response.data
        })
    },
    async updateClient (updatedClient) {
        return axios.patch(client_url + updatedClient.id + '/', updatedClient).then((response) => {
          return response.data
        })
      },
}